export default __webpack_public_path__ + "static/media/logo67.e0cd8c57.jpg";